<div class="lang-switch">
    <div class="switch-track">
        <div
            class="switch-thumb"
            [class.right]="currentLang === 'en'"
            [class.left]="currentLang === 'fr'"
        ></div>

        <button class="switch-option" (click)="switchLang('fr')">
            <img src="https://flagcdn.com/20x15/fr.png" />
        </button>

        <button class="switch-option" (click)="switchLang('en')">
            <img src="https://flagcdn.com/20x15/us.png" />
        </button>
    </div>
</div>
